module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraLightItalic.11db41b5.ttf";